module.exports = __webpack_public_path__ + "static/text@1.5x-a6dc172136080f9b3ac973eb271d6d56.png";